export default __webpack_public_path__ + "static/815-d7c291f997d19545f5b82c17889e4739.gif";